import './Highlights.css'
import parse from 'html-react-parser'

const Highlights = ({ highlights = [] }) => {
  // Guard
  if (!Array.isArray(highlights) || highlights.length === 0) {
    // return null
    return <div className='about__details'>No highlights available</div>
  }

  return (
    <section className='section highlights' aria-labelledby='highlights-title'>
      <h2 id='highlights-title' className='section__title'>
        Career Highlights
      </h2>
      <ul className='highlights__list'>
        {highlights.map((it, idx) => (
          <li
            key={it?.heading || `highlight-${idx}`}
            className='highlight__item'
          >
            <span className='highlight__heading'>{it?.heading}</span>
            {it?.text && (
              <span className='highlight__text'>
                {' '}
                — {typeof it.text === 'string' ? parse(it.text) : it.text}
              </span>
            )}
          </li>
        ))}
      </ul>
    </section>
  )
}

export default Highlights
